export default "__VITE_ASSET__BBkCv9qJ__"